import { render } from "./section-partners.vue?vue&type=template&id=092dca58&scoped=true"
const script = {}

import "./section-partners.vue?vue&type=style&index=0&id=092dca58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092dca58"]])

export default __exports__